var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHumidity = function SvgHumidity(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1034.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4147",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M5.113 1036.7s3.922 5.415 3.922 8.891-2.273 4.613-3.922 4.613-3.923-1.19-3.923-4.613 3.923-8.891 3.923-8.891z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4149",
    fill: "currentColor",
    d: "M11 1037.4h4v1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4151",
    fill: "currentColor",
    d: "M11 1043.4h4v1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4153",
    fill: "currentColor",
    d: "M11 1049.4h4v1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4155",
    fill: "currentColor",
    d: "M14 1037.4h1v12.996h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4157",
    fill: "currentColor",
    d: "M12 1040.4h3v1h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4159",
    fill: "currentColor",
    d: "M12 1046.4h3v1h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4161",
    fill: "currentColor",
    d: "M9.03 1043.3a3.287 4.024 0 0 1-.757 5.095 3.287 4.024 0 0 1-4.229-.035 3.287 4.024 0 0 1-.7-5.107"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHumidity);
export default ForwardRef;